const DemoWarning = ({
  showDemoWarning,
  remainingTime,
  handleCloseWarning,
}) => {
  if (!showDemoWarning) return null;
  return (
    <div className="fixed top-4 right-4 p-6 pointer-events-auto bg-gradient-to-r from-yellow-100 to-yellow-200 border-l-8 border-yellow-600 text-gray-800 rounded-xl shadow-2xl max-w-sm w-full z-50 animate-slide-in">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="text-2xl mt-1">⚠️</span>
          <div>
            <p className="font-bold text-lg tracking-tight">
              Demo API Limitations
            </p>
            <p className="text-sm mt-2 text-gray-700">
              You can only send 100 messages over the next 3 days.
            </p>
            <p className="text-sm mt-2 font-medium text-red-600">
              {remainingTime === "Expired"
                ? "Your demo access has expired."
                : `Time remaining: ${remainingTime}`}
            </p>
          </div>
        </div>
        <button
          onClick={handleCloseWarning}
          className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
          aria-label="Close Warning"
        >
          <span role="img" aria-label="Close" className="text-xl">
            ❌
          </span>
        </button>
      </div>
    </div>
  );
};

export default DemoWarning;
